export function getFreeOrderReasons() {
	return {
		method: 'GET',
		url: `${process.env.REACT_APP_ORIGIN}/free_order_reasons`,
	}
}